<template>
  <el-dialog v-model="dialogVisible" width="1100px" top="50px" :show-close="false">
    <el-container class="calculator-body" v-loading="loading">
      <el-container>
        <el-main id="main">
          <List />
        </el-main>
      </el-container>
    </el-container>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="warning" size="large" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<style scoped>
.el-main {
  padding: 0;
}

.calculator-body {
  height: calc(100vh - 250px);
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}
</style>
<script setup>
import { ref } from 'vue'
import List from '@/components/calculator/List.vue'

const loading = ref(false)
const dialogVisible = ref(false)

const showDialog = () => {
  dialogVisible.value = true
}

defineExpose({ showDialog })

</script>
